<template>
  <div class="programcommen1">
  
    <div class="commenlive">
      
      <div  class="zhanwei" v-show="commenPrograms[0] == 'none'"  >
        <!-- <img src="../../assets/noprogram@2x.png" alt=""> -->
      </div>
      <div class="live"  v-show="commenPrograms[0] != 'none'"  v-for="(item,index) in commenPrograms" :key="index" @click="nextPage(item)">
       
        <div class="img">
          
          <!-- <img src="../../assets/btn_download2.png" alt="" class="programImg"  > -->
          <img :src="item.image" alt="" class="programImg">
           <div class="categoryName" v-if="index <= 2">{{ index + 1}}</div>
            <div class="show-number">
                 <!-- <p class="beforeTime"> 
                  
                 </p> -->
                 <!-- <p class="show_spectators"> -->
                    <div>
                      <img  src="../../assets/see.png" alt=""  class="liveImg1"  >
                    <font>{{item.onlookers}}人</font>
                    </div>
                 <!-- </p> -->
               </div>
        </div>
         <figcaption>
            <p class="liveName">{{item.store_name}}</p>
            <div  class="liveCaption">
              <div class="peice"><font style="font-size: .24rem;">￥</font><font style="font-size: .36rem;">{{item.price}}</font></div>
              <div class="buy">购买</div>
            </div>
            
         </figcaption>
      </div> 
      
      


    </div>

  </div>
</template>

<script>
// let baseurl="http://api.dev.cbct.cn/"
import  {formatDate} from '../../../static/js/date.js'
export default {
  name: 'programcommen1',
  props: ["commenPrograms"],
  data(){
    return { 
     commenProgramData:'',
    //  commonMsg:this.$store.state.commonProgram
    }
  },
  filters: {
    formatDate(time) {
      // time=time.replace("");
      var date = new Date(time*1000);
      return formatDate(date, 'yyyy-MM-dd');
    },
    peopleNumber:function(n1){
        if(n1!="") {
           let strNum="";
         if (n1.length>=5) {
           strNum=(parseFloat(n1/10000).toFixed(1))
         }else{
           strNum=n1
         }
          return strNum     
        }
         
    }
  },
  methods:{
    nextPage:function(item){
      window.location.href=item.h5_url
    },
     toDownloadpage(){
      this.$router.push({path:"downloadApp?isFrom=programRecorded"});
    }
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.programcommen1{
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  padding: 0 .28rem;
  position: relative;
  /* border: solid 1px; */
  
} 
.commenlive{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}
.commenlive .live{
  /* width: 46%; */
  width: 3.36rem;
}
.live .img{
  width: 100%;
  /* height: 1.68rem; */
  height: 1.88rem;
  margin: 0;
  position: relative;
}
.live .categoryName{
  position: absolute;
  left: 0;
  top: 0;
  width:.52rem;
   height: .36rem;
  line-height: .36rem;
  text-align: center;
  font-size:.24rem;
  font-weight:400; 
  color:rgba(255,255,255,1);
  background:rgba(0, 0, 0, .6);
}
.live .img .programImg{
  width: 100%;
  height: 100%;
}
.show-number{
   position: absolute;
   box-sizing: border-box;
   width: 100%;
   bottom: 0.15rem;
   font-size:0.22rem;
   font-weight:bold;
   color:rgba(255,255,255,1);
   text-align: left;
   display: flex;
  justify-content: space-between;
  padding: 0 .16rem;

}
.liveImg{
  width:0.14rem;
  height:0.17rem;
  margin-right: 0.12rem;
}
.liveImg1{
  width:0.26rem;
  height:0.26rem;
  margin-right: 0.12rem;
  vertical-align: middle;
}

.live figcaption{
  box-sizing: border-box;
  width: 100%;
  display: inline-block;
  margin-left:0.04rem;
  font-weight:400;
  text-align: left;
  
}

.liveName{
  font-size:0.3rem;
  color:rgba(51,51,51,1);
  width: 100%;
  height: .72rem;
  line-height: .4rem;
  padding-top:0.16rem;
   text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-weight:600;
}
.liveCaption{
  padding: .16rem 0 .2rem;
  font-size:0.26rem;
  color:red;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.liveCaption .buy{
  width: .98rem;
  height: .52rem;
  line-height: .52rem;
  text-align: center;
  font-size: .24rem;
  border-radius: .26rem;
  border: 1px solid #FF524F;
}
.liveTime{
  font-size:0.22rem;
  color:rgba(153,153,153,1);
  width: 100%;
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  padding-bottom:0.21rem;
}
.zhanwei{
  width:3.24rem;
  margin:0 auto;
  height: 2.6rem;
  margin-top:1rem;
  background: url('../../assets/noprogram@2x.png');
  background-size:100%;
}
.zhanwei img{
  width:3.24rem;
}
</style>
